/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbExamenEntreeDto
 */
export interface FcbExamenEntreeDto {
    /**
     * 
     * @type {number}
     * @memberof FcbExamenEntreeDto
     */
    idexamenEntree?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbExamenEntreeDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbExamenEntreeDto
     */
    pointsmath?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbExamenEntreeDto
     */
    pointsfrancais?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbExamenEntreeDto
     */
    pointslogique?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbExamenEntreeDto
     */
    annee?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbExamenEntreeDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbExamenEntreeDto
     */
    reussite?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbExamenEntreeDto
     */
    dateExamen?: Date | null;
}

/**
 * Check if a given object implements the FcbExamenEntreeDto interface.
 */
export function instanceOfFcbExamenEntreeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExamenEntreeDtoFromJSON(json: any): FcbExamenEntreeDto {
    return FcbExamenEntreeDtoFromJSONTyped(json, false);
}

export function FcbExamenEntreeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExamenEntreeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idexamenEntree': !exists(json, 'idexamenEntree') ? undefined : json['idexamenEntree'],
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'pointsmath': !exists(json, 'pointsmath') ? undefined : json['pointsmath'],
        'pointsfrancais': !exists(json, 'pointsfrancais') ? undefined : json['pointsfrancais'],
        'pointslogique': !exists(json, 'pointslogique') ? undefined : json['pointslogique'],
        'annee': !exists(json, 'annee') ? undefined : json['annee'],
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'reussite': !exists(json, 'reussite') ? undefined : json['reussite'],
        'dateExamen': !exists(json, 'dateExamen') ? undefined : (json['dateExamen'] === null ? null : new Date(json['dateExamen'])),
    };
}

export function FcbExamenEntreeDtoToJSON(value?: FcbExamenEntreeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idexamenEntree': value.idexamenEntree,
        'idapprenant': value.idapprenant,
        'pointsmath': value.pointsmath,
        'pointsfrancais': value.pointsfrancais,
        'pointslogique': value.pointslogique,
        'annee': value.annee,
        'remarque': value.remarque,
        'reussite': value.reussite,
        'dateExamen': value.dateExamen === undefined ? undefined : (value.dateExamen === null ? null : value.dateExamen.toISOString()),
    };
}

